<div
  nz-tooltip
  [nzTooltipTitle]="'rentability.tooltip' | translate"
  class="profitability_score_parent_container"
>
  <span class="profitability_score_title">
    {{ 'rentability.tooltip' | translate }}
  </span>
  <div class="profitability_score-value">
    @if (profitabilityScoreSteps$ | async; as profitabilityScoreSteps) {
      @if (!isLoadingUsersRentability) {
        @if (profitabilityScore) {
          <div>
            @if (
              profitabilityScore | profitabilityIcon: profitabilityScoreSteps;
              as icon
            ) {
              <fa-icon [icon]="icon.name" [style.color]="icon.color"></fa-icon>
              <span class="profitability_score_value">{{
                icon.text | translate
              }}</span>
            }
          </div>
        } @else {
          <span class="profitability_score_value" nzType="secondary">
            {{ 'general.n/a' | translate }}
          </span>
        }
      } @else {
        <div class="skeleton-loading">
          <nz-skeleton
            [nzActive]="true"
            [nzParagraph]="{ rows: 1 }"
            [nzTitle]="false"
          ></nz-skeleton>
        </div>
      }
    }
  </div>
</div>
